import { ModifierGroup } from '@api/ModifierGroups/ModifierGroup';
import ModifierGroupServ from '@api/ModifierGroups/ModifierGroupServ';

class ModifierGroupsService {
    saveModifierGroup = (modifierGroup: ModifierGroup): Promise<ModifierGroup> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await ModifierGroupServ.saveModifierGroup(modifierGroup);
                resolve(data);
            } catch (error) {
                reject('Error saving modifier group: ' + error);
            }
        });
    };
    getModifierGroups = (): Promise<ModifierGroup[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await ModifierGroupServ.getModifierGroups();
                resolve(data);
            } catch (error) {
                reject('Error getting modifier groups: ' + error);
            }
        });
    };
    getModifierGroup = (modifierGroupId: string): Promise<ModifierGroup> => {
        return new Promise(async (resolve, reject) => {
            try {
                const modifierGroup = await ModifierGroupServ.getModifierGroup(modifierGroupId);
                resolve(modifierGroup);
            } catch (error) {
                reject('Error getting modifier group: ' + error);
            }
        });
    };
    deleteModifierGroup = (modifierGroupId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await ModifierGroupServ.deleteModifierGroup(modifierGroupId);
                resolve();
            } catch (error) {
                reject('Error deleting modifier group: ' + error);
            }
        });
    };
}
export default ModifierGroupsService;
